import { createFileRoute } from "@tanstack/react-router";

import { KnowledgeSection } from "../components/regulation/knowledge/KnowledgeSection";

export const Route = createFileRoute("/$org/compliance/knowledge")({
  component: KnowledgeSection,
});
